module.exports = __webpack_public_path__ + "img/Flag_of_Belarus (1).22ec6af9.svg";